import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Zoom } from "@mui/material";
import { useState } from "react";
import { Fade } from "react-awesome-reveal";
import { ISliderData } from "../../exports/interfaces";
import { Link } from "react-router-dom";

const Carousel = (props: { sliderData: ISliderData[] }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const images = props.sliderData?.map((data) => {
    return {
      id: data?.id,
      title: data?.title,
      image: data?.image[0]?.media?.name,
      description: data?.description,
      redirect_link: data?.redirect_link,
    };
  });

  return (
    <>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-f039fdd elementor-section-stretched elementor-section-full_width elementor-section-height-default elementor-section-height-default"
        data-id="f039fdd"
        data-element_type="section"
        data-settings='{"stretch_section":"section-stretched","hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
      >
        <div className="elementor-container elementor-column-gap-default">
          <div className="elementor-row">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d9fe38a"
              data-id="d9fe38a"
              data-element_type="column"
              data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
            >
              <div className="elementor-column-wrap elementor-element-populated">
                <div className="elementor-widget-wrap">
                  <div
                    className="elementor-element elementor-element-2aee847 elementor-widget elementor-widget-hoteller-slider-zoom"
                    data-id="2aee847"
                    data-element_type="widget"
                    data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                    data-widget_type="hoteller-slider-zoom.default"
                  >
                    <div className="elementor-widget-container">
                      <div
                        className="slider_zoom_wrapper custom-slider_zoom_wrapper"
                        style={{ height: "100dvh" }}
                      >
                        <Swiper
                          modules={[Pagination, Autoplay, EffectFade]}
                          spaceBetween={50}
                          slidesPerView={1}
                          pagination={{ clickable: true }}
                          autoplay={{
                            delay: 5000,
                            disableOnInteraction: false,
                          }}
                          speed={1500}
                          onSlideChange={(swiper: any) =>
                            setActiveIndex(swiper.activeIndex)
                          }
                          style={{ height: "100%" }}
                          direction="vertical"
                        >
                          {images?.map((image, index) => {
                            return (
                              <SwiperSlide key={image.id}>
                                <div
                                  className="slideshow__slide-caption custom-slideshow__slide-caption"
                                  style={{
                                    position: "absolute",
                                    bottom: "10%",
                                    // left: "10%",
                                    // transform: "translate(-50%, -50%)",
                                    // color: "white", // Change color as needed
                                    // textAlign: "center",
                                    zIndex: 10,
                                  }}
                                >
                                  <Fade direction="up" delay={500}>
                                    <div className="slideshow__slide-caption-text">
                                      <div
                                        className="container js-parallax title_align_left"
                                        data-speed="2"
                                        data-position="top"
                                      >
                                        <h1 className="slideshow__slide-caption-title">
                                          {image.title}
                                        </h1>
                                        <div className="slideshow__slide-desc">
                                          {image.description}
                                        </div>
                                        <Link
                                          className="slideshow__slide-caption-subtitle -load o-hsub -link"
                                          to={image.redirect_link}
                                        >
                                          <span className="slideshow__slide-caption-subtitle-label">
                                            View Detail
                                          </span>
                                        </Link>
                                      </div>
                                    </div>
                                  </Fade>
                                </div>
                                <Zoom
                                  in={activeIndex === index}
                                  style={{
                                    transitionDelay:
                                      activeIndex === index ? "1000ms" : "0ms",
                                    transform:
                                      activeIndex === index
                                        ? "scale(1)"
                                        : "scale(0.5)",
                                    transition: "transform 0.7s ease",
                                  }}
                                  timeout={1000}
                                >
                                  <div
                                    className="slideshow__slide js-slider-home-slide"
                                    data-slide="1"
                                  >
                                    <div
                                      className="slideshow__slide-background-parallax background-absolute js-parallax"
                                      data-speed="-1"
                                      data-position="top"
                                    >
                                      <div className="slideshow__slide-background-load-wrap background-absolute">
                                        <div className="slideshow__slide-background-load background-absolute">
                                          <div className="slideshow__slide-background-wrap background-absolute">
                                            <div className="slideshow__slide-background background-absolute">
                                              <div className="slideshow__slide-image-wrap background-absolute">
                                                <Fade
                                                  direction="up"
                                                  triggerOnce={true}
                                                >
                                                  <div
                                                    className="slideshow__slide-image background-absolute custom-slideshow__slide-image"
                                                    style={{
                                                      height: "100dvh",
                                                      backgroundImage:
                                                        image?.image
                                                          ? `url(${process.env.REACT_APP_cmsUrl}/uploads/${image?.image})`
                                                          : "url(https://dashboard.scieverinc.com.np/uploads/logo_white3_747fc8e5de.png)",
                                                      backgroundRepeat:
                                                        "no-repeat",
                                                      backgroundSize: "cover",
                                                      backgroundPosition:
                                                        "center",
                                                    }}
                                                  >
                                                    <div className="custom-gradient"></div>
                                                  </div>
                                                </Fade>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Zoom>
                              </SwiperSlide>
                            );
                          })}
                        </Swiper>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Carousel;
